/**
 * ThroughputWidget — Receita liquida de pedidos ENTREGUE no periodo (TOC).
 *
 * Permissao: toc:view. Fonte: GET /api/toc/dashboard (?janela=30d).
 * Drill-down: link para /producao/dbr (KPIs PPCP / Drum-Buffer-Rope).
 */
import React from "react";
import { Link } from "react-router-dom";

import { obterDashboardToc } from "../../../services/toc";

import { CardBody, KpiValor, KpiSub, LinkLight, CardFooter } from "../styles";


export const meta = {
  id: "throughput",
  label: "Throughput (TOC)",
  descricao: "Receita liquida (vendas - TVC) de pedidos entregues no periodo.",
  categoria: "TOC",
  permissoes: ["toc:view"],
  tamanho_default: "M",
  essencial: true,
};

export async function fetchData(request) {
  const payload = await obterDashboardToc(request, { janela: "30d" });
  return payload || null;
}

function fmtMoeda(v) {
  if (v === null || v === undefined) return "—";
  const n = Number(v);
  if (!Number.isFinite(n)) return "—";
  return n.toLocaleString("pt-BR", {
    style: "currency", currency: "BRL", maximumFractionDigits: 0,
  });
}

export function Widget({ dados }) {
  const tp = dados?.throughput || {};
  const bruto = tp.bruto_total ?? tp.bruto ?? null;
  const liquido = tp.liquido_total ?? tp.throughput_liquido ?? null;
  const janela = tp.janela || dados?.janela || "30d";

  return (
    <>
      <CardBody>
        <KpiValor>{fmtMoeda(liquido ?? bruto)}</KpiValor>
        <KpiSub>
          {liquido != null && bruto != null && (
            <>Bruto: {fmtMoeda(bruto)} | </>
          )}
          Janela: {janela}
        </KpiSub>
      </CardBody>
      <CardFooter>
        <LinkLight as={Link} to="/producao/dbr">Ver KPIs PPCP</LinkLight>
      </CardFooter>
    </>
  );
}
